
import React, { useState } from "react";

function Navbar({ isAdmin, onAddProjectClick }) {
  const [menuOpen, setMenuOpen] = useState(false);

  // Smooth scroll handler
  const handleSmoothScroll = (e, id) => {
    e.preventDefault();
    setMenuOpen(false);
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };
  
  return (
    <nav className="sticky top-0 z-50 px-6 py-3 shadow-2xl backdrop-blur-md bg-gradient-to-r from-gray-900/90 via-gray-800/90 to-teal-900/90">
      <div className="flex items-center justify-between mx-auto max-w-7xl">
        <h1 className="text-3xl font-extrabold tracking-tight text-teal-400 drop-shadow-lg">ShaheerDev</h1>
     
        <ul className="hidden gap-8 text-lg font-medium md:flex">
          <li><a href="#hero" className="transition-colors duration-200 hover:text-teal-400" onClick={e => handleSmoothScroll(e, 'hero')}>Home</a></li>
          <li><a href="#about" className="transition-colors duration-200 hover:text-teal-400" onClick={e => handleSmoothScroll(e, 'about')}>About</a></li>
          {isAdmin && (
            <li>
              <button
                onClick={onAddProjectClick}
                className="transition-colors duration-200 bg-transparent border-none outline-none cursor-pointer hover:text-teal-400"
                style={{ padding: 0 }}
              >
                Add Project
              </button>
            </li>
          )}
          <li><a href="#projects" className="transition-colors duration-200 hover:text-teal-400" onClick={e => handleSmoothScroll(e, 'projects')}>Projects</a></li>
          <li><a href="#contact" className="transition-colors duration-200 hover:text-teal-400" onClick={e => handleSmoothScroll(e, 'contact')}>Contact</a></li>
        </ul>
 
        <button
          className="md:hidden flex flex-col gap-1.5 group"
          aria-label="Toggle menu"
          onClick={() => setMenuOpen((prev) => !prev)}
        >
          <span className={`block h-1 w-8 rounded bg-teal-400 transition-all duration-300 ${menuOpen ? 'rotate-45 translate-y-2' : ''}`}></span>
          <span className={`block h-1 w-8 rounded bg-teal-400 transition-all duration-300 ${menuOpen ? 'opacity-0' : ''}`}></span>
          <span className={`block h-1 w-8 rounded bg-teal-400 transition-all duration-300 ${menuOpen ? '-rotate-45 -translate-y-2' : ''}`}></span>
        </button>
      </div>

      <div
        className={`md:hidden transition-all duration-300 ${menuOpen ? 'max-h-60 py-4 opacity-100' : 'max-h-0 opacity-0 overflow-hidden'} bg-gray-900/95 rounded-b-xl mt-2 shadow-xl`}
      >
        <ul className="flex flex-col gap-4 px-6 text-lg font-medium">
          <li><a href="#hero" className="transition-colors duration-200 hover:text-teal-400" onClick={e => handleSmoothScroll(e, 'hero')}>Home</a></li>
          <li><a href="#about" className="transition-colors duration-200 hover:text-teal-400" onClick={e => handleSmoothScroll(e, 'about')}>About</a></li>
          {isAdmin && (
            <li>
              <button
                onClick={() => { setMenuOpen(false); onAddProjectClick && onAddProjectClick(); }}
                className="w-full text-left transition-colors duration-200 bg-transparent border-none outline-none cursor-pointer hover:text-teal-400"
                style={{ padding: 0 }}
              >
                Add Project
              </button>
            </li>
          )}
          <li><a href="#projects" className="transition-colors duration-200 hover:text-teal-400" onClick={e => handleSmoothScroll(e, 'projects')}>Projects</a></li>
          <li><a href="#contact" className="transition-colors duration-200 hover:text-teal-400" onClick={e => handleSmoothScroll(e, 'contact')}>Contact</a></li>
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;
